import { render, staticRenderFns } from "./FormCredits.vue?vue&type=template&id=30cf6434&scoped=true&"
import script from "./FormCredits.vue?vue&type=script&lang=js&"
export * from "./FormCredits.vue?vue&type=script&lang=js&"
import style0 from "./FormCredits.vue?vue&type=style&index=0&id=30cf6434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cf6434",
  null
  
)

export default component.exports